export default () => (
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.15137 3.84907L7.99994 1.00012L10.8489 3.84907"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.14936 7.15247H2.92798C2.07431 7.15247 1.38281 7.84434 1.38281 8.69763V17.4543C1.38281 18.308 2.07431 18.9999 2.92798 18.9999H13.0726C13.9262 18.9999 14.6177 18.308 14.6177 17.4543V8.69763C14.6177 7.84434 13.9262 7.15247 13.0726 7.15247H11.8512"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 11.7705V1.00012"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
